import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {CreateUpdateDefaultPagePage} from './create-update-default-page.page';
import {CreateUpdateDefaultModule} from "../../component/create-update-default/create-update-default.module";
import {DefaultAppPageModule} from "../../../../components/common/defaut-application-page/default-app-page.module";
import {ContentModule} from "../../../../shared/directives/content.module";
import {ContentDirective} from "../../../../shared/directives/content.directive";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
      ReactiveFormsModule,
    DefaultAppPageModule,
      ContentModule,
    CreateUpdateDefaultModule,
  ],
  declarations: [CreateUpdateDefaultPagePage],
  exports: [CreateUpdateDefaultPagePage, ContentDirective]
})
export class CreateUpdateDefaultPagePageModule {}
